// removed by extract-text-webpack-plugin
module.exports = {"shipment-tabs":"ShipmentTabs-module__shipment-tabs___2vjmn","title":"ShipmentTabs-module__title___1csXJ","tabs":"ShipmentTabs-module__tabs___205H7"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Status/ShipmentTabs/ShipmentTabs.module.scss
// module id = 217
// module chunks = 0 1